import axios from 'axios'

const tiempopedidos = {

    PostCrearEditar: (datos) => axios.post(`tiempos-pedidos/crear-tiempos-pedido`,datos),
    GetTiemposPedidos: (tienda) => axios.get(`tiempos-pedidos/${tienda}/listar-tiempos-pedidos`),
}
export default tiempopedidos
